import { Button, TextField } from '@mui/material'
import { Search } from '@mui/icons-material'
import React from 'react'

interface SearchInputProps {
  value: unknown
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  buttonType?: 'button' | 'submit' | 'reset'
  buttonClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  buttonType = 'submit',
  buttonClick = undefined
}) => {
  return (
    <div style={{ alignItems: 'center', justifyItems: 'center' }}>
      <TextField
        variant='outlined'
        id='standard-name'
        label='Usuario...'
        value={value}
        onChange={onChange}
        placeholder='Nombre de usuario...'
      />
      <Button
        type={buttonType}
        onClick={buttonType !== 'submit' ? buttonClick : undefined}
        variant='contained'
        color='primary'
        style={{ height: '56px' }}
      >
        <Search />
      </Button>
    </div>
  )
}
